<template>
  <ElementVotes
    :votes="fulfillmentVotes"
    :current-user-vote-type="userVoteType"
    @voteClick="voteClick"
  />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ElementVotes from '../ElementVotes';
import { types as voteTypes } from '../../../store/votes';
import { types as userTypes } from '../../../store/user';

export default {
  name: 'FulfillmentVotes',
  components: {
    ElementVotes,
  },
  props: {
    analysisId: {
      type: String,
      required: true,
    },
    userAnalysisId: {
      type: String,
      required: true,
    },
    fulfillmentId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getVotes: voteTypes.getters.votes,
      getCurrentUserVote: voteTypes.getters.currentUserVote,
      user: userTypes.getters.userDetails,
    }),
    fulfillmentVotes() {
      return this.getVotes(this.collectionPath);
    },
    userVoteType() {
      const currentUserVote = this.getCurrentUserVote(this.collectionPath);

      return currentUserVote ? currentUserVote.voteType : undefined;
    },
    userId() {
      return this.user.userId;
    },
    collectionPath() {
      return `/analyses/${this.analysisId}/userAnalyses/${
        this.userAnalysisId}/missionFulfillments/${this.fulfillmentId}/missionFulfillmentVotes/`;
    },
    path() {
      return this.collectionPath + this.userId;
    },
  },
  methods: {
    ...mapActions({
      writeVote: voteTypes.actions.writeVote,
      fetchVotes: voteTypes.actions.fetchVotes,
    }),
    voteClick(voteType) {
      this.writeVote({
        path: this.path,
        vote: {
          userId: this.userId,
          voteType,
        },
      });
    },
  },
  created() {
    this.fetchVotes(this.collectionPath);
  },
};
</script>
